import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { SaveSiteLockCodes, SiteLockCodesResponse } from '../interfaces/site-lock-codes-response';

@Injectable({
    providedIn: 'root'
})

export class SiteLockCodesService {
    baseUrl = environment.baseUrl;
    constructor(private http: HttpClient) { }

    getSiteLockCodesById(siteId: number): Observable<SiteLockCodesResponse[]> {
        var url = `${this.baseUrl}sitelockcodes/${siteId}`;
        return this.http.get<SiteLockCodesResponse[]>(url);
    }
    saveSiteLockCodes(payload:SaveSiteLockCodes) {
        var url = `${this.baseUrl}sitelockcodes`;
        return this.http.post<boolean>(url, payload);
    }
}